/* eslint-disable no-shadow */

const getFlatToc = (toc, parentId) => {
  if (!toc) return [];

  const node = toc.length ? toc : [toc];

  return node.reduce((acc, node) => {
    const { id } = node;
    const { children, ...nodeWithoutChildren } = node;

    if (children) {
      const currentNode = parentId ? { ...nodeWithoutChildren, parentId } : nodeWithoutChildren;
      return [...acc, currentNode, ...getFlatToc(children, id)];
    }

    return [...acc, { ...node, parentId }];
  }, []);
};

export default getFlatToc;
